import { render, staticRenderFns } from "./StepOrderedTags.vue?vue&type=template&id=61930269&scoped=true&"
import script from "./StepOrderedTags.vue?vue&type=script&lang=js&"
export * from "./StepOrderedTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61930269",
  null
  
)

export default component.exports